import CategoryModal from './CategoryModal.view';

export default CategoryModal;
